import { useState } from 'react';
import { IModalConfig } from '../../components/customModal';

const useModalProvider = () => {
	const [modalConfig, setModalConfig] = useState<IModalConfig>({ isOpen: false });

	return { modalConfig, setModalConfig };
};

export default useModalProvider;
